<template>
  <div>
    <div class="row justify-content-end align-items-end">
      <div class="col"></div>
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
          Actualiser
        </button>
      </div>
    </div>
    <br />

    <vue-data-table :headers="headers" :data="shares" :buttons="buttons" :itemsPerPage="10">
      <template #cell-sharedBy="{ row }">
        {{ row.sharedByFullName || 'N/A' }}
      </template>

      <template #cell-sharedWith="{ row }">
        {{ row.sharedWithFullName || 'N/A' }}
      </template>

      <template #cell-date="{ row }">
        {{ formatDate(row.created_at) }}
      </template>

      <template #cell-time="{ row }">
        {{ formatTime(row.created_at) }}
      </template>

      <template #cell-remark="{ row }">
        {{ row.remark || '-' }}
      </template>


    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      headers: [
        { label: "ID", field: "id", class: "text-center" },
        { label: "Partagé par", field: "sharedByFullName", class: "text-left" },
        // { label: "Partagé avec", field: "sharedWithFullName", class: "text-left" },
        { label: "Date", field: "date", class: "text-center" },
        { label: "Heure", field: "time", class: "text-center" },
        { label: "Remarque", field: "remark", class: "text-left" },
      ],
      buttons: [
        {
          label: "Supprimer",
          icon: "bi bi-trash",
          class: "btn-danger",
          action: (row) => this.remove(row),
        },
        {
          label: "Aller à",
          icon: "bi bi-arrow-right-circle",
          class: "btn-success",
          action: (row) => this.navigateToSharedRoute(row),
        },
      ],
    };
  },
  computed: {
    ...mapGetters("share", {
      shares: "getShares",
    }),
  },
  mounted() {
    this.$store.dispatch("share/getAll");
  },
  methods: {
    async remove(share) {
      await this.$confirm({
        message: `Voulez-vous vraiment supprimer le partage #${share.id} ?`,
        button: {
          no: "Non",
          yes: "Oui",
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch("share/destroy", share.id);
          }
        },
      });
    },

    async refresh() {
      await this.$store.dispatch("share/getAll");
    },

    // navigateToSharedRoute(share) {
    //   try {
    //     if (share.routeName) {
    //       const routeParams = share.params || {};
    //       const routeQuery = share.query || {};

    //       this.$router.push({
    //         name: share.routeName,
    //         params: routeParams,
    //         query: routeQuery
    //       });
    //     } else {
    //       this.$toast.error("Aucune route spécifiée pour ce partage");
    //     }
    //   } catch (error) {
    //     console.error("Navigation error:", error);
    //     this.$toast.error("Impossible de naviguer vers la destination partagée");
    //   }
    // },

    navigateToSharedRoute(share) {
      try {
        if (share.routeName) {
          // Parse the JSON strings back to objects
          const routeParams = typeof share.params === 'string' ? JSON.parse(share.params) : share.params || {};
          const routeQuery = typeof share.query === 'string' ? JSON.parse(share.query) : share.query || {};

          this.$router.push({
            name: share.routeName,
            params: routeParams,
            query: routeQuery
          });
        } else {
          this.$toast.error("Aucune route spécifiée pour ce partage");
        }
      } catch (error) {
        console.error("Navigation error:", error);
        this.$toast.error("Impossible de naviguer vers la destination partagée");
      }
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString('fr-FR');
    },

    formatTime(date) {
      return new Date(date).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    },


  },
};
</script>

<style scoped>
.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.me-2 {
  margin-right: 0.5rem;
}
</style>